import $ from 'jquery';

window.addEventListener('load', event => {
    const flipBooks = document.querySelectorAll('[data-flipbook][data-src]');

    $().ready(() => {
        for (let flipBook of flipBooks) {
            const pdfSource = flipBook.getAttribute('data-src');

            Element.prototype.remove = function() {
                if (this.parentNode) {
                    this.parentNode.removeChild(this);
                }
            };

            let options = '';
            let windowWidth = window.innerWidth;
            let height = windowWidth * 1.4;
            let heightInRem = '43.75rem';
            let heightInRemMobile = '23.75rem';

            if (window.matchMedia('(max-width: 1024px)').matches) {
                if (height > 700) {
                    height = 700;
                }
                options = { height: heightInRemMobile, duration: 800, pageMode: 1, backgroundColor: 'transparent', hard: 'none' };
            } else {
                height = windowWidth / 4 * 3 * 1.4;
                if (height > 700) {
                    height = 700;
                }
                options = { height: heightInRem, duration: 800, pageMode: 2, backgroundColor: 'transparent', hard: 'none' };
            }

            //Initialise flipbooks
            $(flipBook).flipBook(pdfSource, options);
        }
    })
});
